import React, { Suspense, lazy, type ComponentType } from 'react'

type DynamicOptions<P> = {
  loading?: () => React.ReactNode
  ssr?: boolean
}

/** React.lazy + Suspense wrapper (historically shaped like `next/dynamic`). */
export default function lazyWithSuspense<P = Record<string, unknown>>(
  factory: () => Promise<{ default: ComponentType<P> }>,
  options?: DynamicOptions<P>,
): ComponentType<P> {
  const Lazy = lazy(factory)

  function DynamicComponent(props: P) {
    return (
      <Suspense fallback={options?.loading?.() ?? null}>
        <Lazy {...(props as object)} />
      </Suspense>
    )
  }

  DynamicComponent.displayName = 'LazyWithSuspense'
  return DynamicComponent as ComponentType<P>
}
